/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Credentials_MissingInputs */

const cs_sreality_credentials_missing = /** @type {(inputs: Sreality_Credentials_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chybí klíče RK`)
};

const en_sreality_credentials_missing = /** @type {(inputs: Sreality_Credentials_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RK keys missing`)
};

/**
* | output |
* | --- |
* | "RK keys missing" |
*
* @param {Sreality_Credentials_MissingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_credentials_missing = /** @type {((inputs?: Sreality_Credentials_MissingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Credentials_MissingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_credentials_missing(inputs)
	return cs_sreality_credentials_missing(inputs)
});